import Drawer from '@/common/components/Drawer/Drawer';
import { LelyRadioButton } from '@/common/components';
import { SettingsDrawerProps } from '../ManageSettings';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '@/reducers/rootReducer';
import {
  setUnitPreference,
  userDetailsSelectors,
} from '@/reducers/userDetailsSlice';
import { useEffect, useState } from 'react';
import { unitsArray, PREFERRED_UNIT } from '@/common/constants';
import { Box, RadioGroup, Typography } from '@mui/material';
const ManageUnitDrawer = ({
  open,
  onClose,
  onCloseAll,
}: SettingsDrawerProps) => {
  const dispatch = useDispatch();
  const unit = useAppSelector(userDetailsSelectors.selectUnitPreference);
  const [draftUnit, setDraftUnit] = useState(unit);

  const handleUnitChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDraftUnit(event.target.value);
  };
  const hasUnsavedChanges = draftUnit !== unit;

  useEffect(() => {
    if (open) setDraftUnit(unit);
  }, [open, unit]);

  const handleUnitApply = () => {
    dispatch(setUnitPreference(draftUnit));
    localStorage.setObject(PREFERRED_UNIT, draftUnit as any);
    onClose();
  };

  return (
    <Drawer
      title="Unit"
      open={open}
      onApply={handleUnitApply}
      onClose={onClose}
      onCloseAll={onCloseAll}
      showFooter={true}
      showBackButton={true}
      invisibleBackdrop
      hasUnsavedChanges={hasUnsavedChanges}
    >
      <>
        <Box display="flex" flexDirection="column" gap={2}>
          <Typography variant="body2" color="text.primary">
            This setting is currently only applicable for Vector.
          </Typography>
          <RadioGroup value={draftUnit} onChange={handleUnitChange}>
            {unitsArray.map((unitOption) => (
              <LelyRadioButton
                key={unitOption}
                value={unitOption}
                label={unitOption}
              />
            ))}
          </RadioGroup>
        </Box>
      </>
    </Drawer>
  );
};

export default ManageUnitDrawer;
